document.querySelectorAll(".scroll-to-audit").forEach(function(element) {
	element.addEventListener("click", function (e) {
		e.preventDefault();
	  
		const smoother = ScrollSmoother.get();
		const target = document.querySelector("#audit-report-form");
	  
		if (smoother && target) {
		  smoother.scrollTo(target, true, "top top+=100");
		} else if (target) {
		  gsap.to(window, {
			duration: 1.5,
			scrollTo: { y: target, offsetY: 100 },
			ease: "power2.inOut"
		  });
		}
	});
});

  
    let faq_block = gsap.matchMedia();
    faq_block.add("(min-width: 1024px)", () => {
        let leftDivHeight = document.getElementById('report-left').clientHeight;
        let rightDivHeight = document.getElementById('report-right').clientHeight;
        let travelDistance = rightDivHeight - leftDivHeight;
        gsap.to("#report-left", {
            scrollTrigger: {
                trigger: "#report-left",
                start: "top 10%",
                end:  `+=${travelDistance}`,
                pin: true,
                pinSpacing: false
            }
        });
    });



	let mm = gsap.matchMedia();

	mm.add("(min-width: 1024px)", () => {
		gsap.to(".global-highlights .bg-dot-animation", { 
			width: "832px",
			height: "832px",
			y: "-17%",
			duration: 1,
			scrollTrigger: {
				trigger: ".global-highlights",
				start: "top 65%",
				end: "top top",
				scrub: 1
			}
		});
	});

	mm.add("(max-width: 1023px)", () => {
		gsap.to(".global-highlights .bg-dot-animation", { 
			scale: 5,
			y: "100%",
			duration: 1,
			scrollTrigger: {
				trigger: ".global-highlights",
				start: "top 65%",
				end: "top top",
				scrub: 1
			}
		});
	});

	const processStepsTimeline = document.querySelector('#process-steps-timeline');
	if (processStepsTimeline) {
		const stepItems = gsap.utils.toArray('.step-item');
		
		stepItems.forEach((step, index) => {
			const dot = step.querySelector('.connector-dot');
			const lineFill = step.querySelector('.connector-line-fill');
			const stepContent = step.querySelector('.step-content');
			const isLastStep = index === stepItems.length - 1;
			const isFirstStep = index === 0;
			const nextStep = stepItems[index + 1];

			// First step is always active on load
			if (isFirstStep) {
				gsap.set(dot, { opacity: 1 });
				dot.classList.add('active');
				gsap.set(stepContent, { opacity: 1, y: 0 });
			} else {
				// Set initial state for non-first steps
				gsap.set(dot, { opacity: 0.5 });
				gsap.set(stepContent, { opacity: 0, y: 20 });
			}

			// Line fill animation with callbacks
			if (!isLastStep && nextStep) {
				const nextDot = nextStep.querySelector('.connector-dot');
				const nextStepContent = nextStep.querySelector('.step-content');
				
				gsap.timeline({
					scrollTrigger: {
						trigger: step,
						start: "bottom 80%",
						end: () => `+=${nextStep.offsetTop - step.offsetTop - step.offsetHeight}`,
						scrub: 0.5,
						onUpdate: (self) => {
							// When line is fully filled (scroll down)
							if (self.progress >= 0.95 && self.direction === 1) {
								gsap.to(nextDot, { 
									opacity: 1, 
									duration: 0.3,
									ease: "back.out(2)"
								});
								nextDot.classList.add('active');
								
								gsap.to(nextStepContent, {
									opacity: 1,
									y: 0,
									duration: 0.5,
									ease: "power2.out"
								});
							}
							// When line starts emptying (scroll up)
							else if (self.progress < 0.05 && self.direction === -1) {
								gsap.to(nextDot, { 
									opacity: 0.5, 
									duration: 0.3 
								});
								nextDot.classList.remove('active');
								
								gsap.to(nextStepContent, {
									opacity: 0,
									y: 20,
									duration: 0.5,
									ease: "power2.in"
								});
							}
						},
						onRefresh: (self) => {
							// Check if line should be filled on page load
							if (self.progress > 0) {
								gsap.set(lineFill, { height: `${self.progress * 100}%` });
								
								// If line is fully filled, activate next step
								if (self.progress >= 0.95) {
									gsap.set(nextDot, { opacity: 1 });
									nextDot.classList.add('active');
									gsap.set(nextStepContent, { opacity: 1, y: 0 });
								}
							}
						}
					}
				})
				.fromTo(lineFill, {
					height: "0%"
				}, {
					height: "100%",
					ease: "none"
				});
			}
		});
	}